import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PN_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#PN_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PN_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#PN_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PN_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#PN_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PN_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#PN_svg__d)"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.616 10.757s.098 1.095-.118 1.715c-.217.62-.327.98-.327.584 0-.397-.152-.71-.274-.71-.122 0-.026.392-.149.392s-.546.068-.546-.162-.056.618.22.694c.274.075-.134.31-.317.238 0 0 .75.244 1.044.451 0 0 .88 1.1 1.705.966 0 0-1.122-.388-.924-1.128.197-.74.924-.847.924-.847s.34.114.33.413c-.01.299.25-.093.25-.093s.042-.378-.004-.47c-.046-.092.78-.27.833-.66 0 0-.845.04-.903-.06-.058-.1.261-.257.161-.451-.1-.195-1.591 1.11-1.591 1.11s.515-.888.515-1.365-.131-.803-.515-.803c-.385 0-.314.186-.314.186zM28.382 11.017c0 .001.001.003.003.001.055-.055.398-.37.684-.12.314.272-.157.537-.157.537s.22.213.472.213c.251 0 .313-.213.313-.213s.02.475.84.655c0 0 .294-.42 0-.651 0 0 .347-.072.322-.352 0 0-.285.097-.488-.126s-.598-.326-.886-.274c-.73-.264-1.058.252-1.103.33z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.402 13.415s.85 1.597.319 1.928c-.531.331 2.523.096 2.811 0 .288-.095-.058-.599-.377-.739-.32-.14-1.631-.605-1.98-.955-.35-.351-.136-.476.145-.822.281-.347 1.322-.485 1.322-.809 0-.323.66-1.658 1.122-1.76.46-.1.212-.259.105-.259-.105 0-.744.658-.985.54-.242-.12-.272-.11 0-.398.271-.286.475-.616.117-.379-.36.237-.95.613-1.235.613-.284 0-1.297-.128-1.17.163.125.292.178.797.724 1.139.546.341.308.591-.145.92-.454.33-.773.818-.773.818z",
      fill: "#96877D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M29.038 11.303l-1.618 3.245s-.047.917 1.11.306c1.156-.61 1.11-1.044 1.444-1.044.334 0 .44-.185.44-.185l-.222-.175s-.026-.319.115-.39c0 0-.276-.152-.316-.026-.04.127-.234-.265-.124-.265 0 0-.243.394-.295.548 0 0-.352-.143-.335-.807.017-.663-.199-1.207-.199-1.207zM21.336 10.789s-.824.192-.735.391c.089.2.22-.005-.184.235 0 0-.709.548-.863.489-.154-.06.11.138.11-.489 0-.626-.412-.116 0-.534.41-.419.555-.092.753-.333.198-.24.02-.113.557-.113s.362.354.362.354zM23.85 14.014s-2.307 1.813-2.768 1.948c-.461.135.948-.037 1.293-.277.344-.239 1.475-1.671 1.475-1.671z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.425 17.195s.221 1.428-.357 1.287c-.578-.14-.818-.213-.818-.213s.212.665.515.665c0 0 .516 1.006.318 1.324 0 0 .889-.721.745-1.295-.143-.573.23.095.23.095s.327.157.564-.019c.236-.176-.003-.098-.24-.434-.236-.336-.178-1.28-.897-1.768-.72-.49-.887-.474-.887-.474s-.53-.866-.213-.809c0 0 2.275.78 2.335.98.059.2.662.163.36-.408-.301-.572-1.928-.916-2.121-1.078-.194-.16-.014-.772-.361-.905-.348-.133-1.297-1.078-1.297-1.534 0-.455-.446-.67-.835-.67-.388 0-1.12-.112-1.429-.112-.309 0-.597.517-.298.517.298 0 .043.968-.457 1.18-.5.211-.886.515-1.457.515-.571 0 .808.492 1.028.298.22-.194.147-.484.886-.813.738-.33 1.442-.525 1.353-.263-.09.263.138.701.486.543.348-.16.46-.56.46-.28s.533 1.717.94 2.278c.407.561 1.447 1.393 1.447 1.393z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.57 11.945s-.27.431 0 .431c.271 0 .706 0 .441-.215-.265-.216-.44-.216-.44-.216zM24.475 11.935s0 .287.188.287.355.286.355 0c0-.287.26-.192-.142-.287-.401-.095-.401 0-.401 0zM25.63 12.001s-.181.136-.09.379c.09.242.294.723 0 .723-.296 0-.538.173-.308.173.23 0 .64.173.64 0s.167.286.167 0v-.59c0-.167.166-.215 0-.45-.167-.235-.41-.235-.41-.235zM26.047 13.672s.377 1.185.581 1.338c.205.153.297 1.44.387 1.58.09.14 1.315.847 1.315 1.226s.377-.291.188-.667c-.188-.375-.782-1.175-1.21-1.349-.426-.174-.372-.596-.462-.893-.09-.297.532.24 0-.433-.53-.673-.517-.312-.367-.312.15 0 .299-.08.15-.184-.15-.104-.582-.306-.582-.306zM22.054 16.116s-1.224 2.16-1.442 2.273c-.218.111-.381.134-.493 0-.111-.135-.123.36 0 .495.123.136.493.136.698-.105 0 0 .032.608.352 1.066.32.459.453.332.453.591 0 .26.075.602.173.602.097 0 .173.816 0 .816s.4.067.65-.137c.251-.204.358-.36.305-.36-.054 0-.696-.337-.696-.577 0-.24-.432-.426-.432-.782 0-.355-.225-.777-.225-.945 0-.169.192.064.398-.095.205-.159.259-.57.259-.57s-.324.218-.432.11c-.109-.11-.45-.324-.225-.692.225-.367.657-1.69.657-1.69z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.174 9.302s-.438.195-.292.484c.146.29.199.418.292.354.094-.064.75-.186.603-.512-.147-.326-.455-.326-.455-.326h-.148z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.694 9.146s-.579-.256-.386 0c.193.256.44.39.617.39.178 0 .546-.052.362-.156-.184-.103-.593-.234-.593-.234z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.981 15.8c.003-.015-.016-.026-.027-.015-.12.116-.482.499-.328.832.183.397.366.535.366.535s.111.609.341.774c0 0 .31-.015.325-.49 0 0 .525-.153.68.175 0 0-.102.037-.102.315 0 .28.238.581.238.581s.109-.961.598-1.581.629-.742.629-.742v-.698s-1.012.825-1.227 1.51c0 0-.51.018-.717-.07-.207-.088.259-.232 0-.544-.259-.312-.14.44-.424.235-.443-.123-.382-.65-.352-.816z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.186 15.194h5.184v3.168s-.422 2.588-2.68 3.863c0 0-2.187-1.292-2.505-3.863v-3.168z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PN_svg__e",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 22,
      y: 15,
      width: 6,
      height: 8
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.186 15.194h5.184v3.168s-.422 2.588-2.68 3.863c0 0-2.187-1.292-2.505-3.863v-3.168z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#PN_svg__e)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.65 15.023l-2.265 4.701 3.072-2.79 2.114 3.505v-5.416l-2.114 1.734-.807-1.734z",
      fill: "#58A5FF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.578 18.413a.17.17 0 11.338 0v3.018a.17.17 0 01-.338 0v-3.018z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.99 19.157a.166.166 0 110-.332h1.527a.166.166 0 110 .332H23.99zM24.815 21.488l-.13.106c-.194-.234-.37-.347-.525-.347-.229 0-.415-.19-.566-.553l.156-.064c.128.306.268.45.41.45.216 0 .433.139.655.408z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.442 20.119h-.003v.817c0 .001.002.002.003.001l.613-.252c.002 0 .002-.002 0-.003l-.613-.563z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.675 21.488l.13.106c.194-.234.37-.347.525-.347.229 0 .415-.19.567-.553l-.156-.064c-.129.306-.268.45-.411.45-.216 0-.433.139-.655.408z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.048 20.119h.003v.817a.002.002 0 01-.002.001l-.614-.252c-.001 0-.002-.002 0-.003l.613-.563z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M24.406 17.059h.676v1.007h-.676z" }))))
), a = t;
export {
  a as default
};
